import { Link } from 'react-router-dom';
import { useEffect } from 'react';
import { useCart } from '../hooks/useCart';

export function CheckoutSuccessPage() {
  const { clearCart } = useCart();

  useEffect(() => {
    clearCart();
  }, [clearCart]);

  return (
    <div className="mx-auto max-w-lg py-12 text-center">
      <div className="flex justify-center">
        <div className="flex h-16 w-16 items-center justify-center rounded-full bg-green-600/20">
          <svg className="h-8 w-8 text-green-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
          </svg>
        </div>
      </div>
      <h1 className="mt-4 text-2xl font-bold text-white">Payment Successful!</h1>
      <p className="mt-2 text-gray-400">
        Thank you for your purchase. Your license keys have been generated and are available in your account.
      </p>
      <div className="mt-8 flex justify-center gap-4">
        <Link to="/account" className="rounded-lg bg-green-600 px-4 py-2 text-sm font-medium text-white hover:bg-green-500 transition-colors">
          View Account
        </Link>
        <Link to="/" className="rounded-lg border border-white/10 px-4 py-2 text-sm text-gray-300 hover:bg-white/5 transition-colors">
          Continue Shopping
        </Link>
      </div>
    </div>
  );
}
